import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

export interface TabProps {
  label: string
  selected?: boolean
  onClick?: () => void
  dataTestId?: string
}

const TabButton = styled.button<{ selected: boolean }>`
  font-size: 13px;
  outline: none;
  height: 100%;
  padding: 0 9px;
  color: ${constants.CORE_PRIMARY_6};
  background-color: ${props => props.selected && constants.CORE_PRIMARY};
`

export class Tab extends React.Component<TabProps> {
  render() {
    const { onClick, label, selected, dataTestId } = this.props
    return (
      <TabButton data-test-id={`${dataTestId}-${label}`} onClick={onClick} selected={selected || false}>
        {label}
      </TabButton>
    )
  }
}
